'use client';

import { c as _c } from "react/compiler-runtime";
import { useAuth } from '@morfi/backend-sdk-v2/client';
import { fundingLocationOverrideEnabled } from '@/lib/dev/funding-devtools-policy';
import { useNetworkConfig } from '@/lib/network/use-network-config';
import { useFundingDevtoolsStore } from '@/stores/funding-devtools';
export function useFundingLocationOverride() {
  const $ = _c(7);
  const {
    user,
    isAuthenticated
  } = useAuth();
  const {
    network
  } = useNetworkConfig();
  let t0;
  if ($[0] !== user) {
    t0 = state => user ? state.preferences[user.id] : false;
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const preference = useFundingDevtoolsStore(t0);
  let t1;
  if ($[2] !== isAuthenticated || $[3] !== network || $[4] !== preference || $[5] !== user?.email) {
    t1 = isAuthenticated && fundingLocationOverrideEnabled(user?.email, network, preference);
    $[2] = isAuthenticated;
    $[3] = network;
    $[4] = preference;
    $[5] = user?.email;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}